interface JsonLdProps {
  data: Record<string, unknown>;
}

/**
 * Renders JSON-LD structured data for SEO.
 * Place inside page components alongside DocumentHead.
 *
 * Usage: <JsonLd data={{ "@type": "Organization", name: "Rusha", ... }} />
 */
export function JsonLd({ data }: JsonLdProps) {
  const json = JSON.stringify({
    "@context": "https://schema.org",
    ...data,
  });

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
}
